import React, {Component} from 'react'
import {Map as LeafletMap, Marker, Popup, TileLayer} from 'react-leaflet'
import L from 'leaflet'
import scooterIcon from './img/scooter-icon.png'
import scooterIconB1 from './img/scooter-icon-b1.png'
import scooterIconB2 from './img/scooter-icon-b2.png'
import scooterIconB3 from './img/scooter-icon-b3.png'
import bicycleIcon from './img/bike-icon.png'
import bicycleIconB1 from './img/bike-icon-b1.png'
import bicycleIconB2 from './img/bike-icon-b2.png'
import bicycleIconB3 from './img/bike-icon-b3.png'
import currentIcon from './img/current-marker.png'
import bike from './img/bike@100x100.png'
import scooter from './img/scooter@100x100.png'
import ring from './img/ring-icon.png'
import 'leaflet/dist/leaflet.css'
import 'react-leaflet-markercluster/dist/styles.min.css'
import './Map.css'
import {Button, Col, message, Modal, Row} from "antd";
import {getRideApi} from "api";
import MarkerClusterGroup from "react-leaflet-markercluster";

const ScooterIcon = L.icon({iconUrl: scooterIcon, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const ScooterIconB1 = L.icon({iconUrl: scooterIconB1, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const ScooterIconB2 = L.icon({iconUrl: scooterIconB2, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const ScooterIconB3 = L.icon({iconUrl: scooterIconB3, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const BicycleIcon = L.icon({iconUrl: bicycleIcon, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const BicycleIconB1 = L.icon({iconUrl: bicycleIconB1, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const BicycleIconB2 = L.icon({iconUrl: bicycleIconB2, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const BicycleIconB3 = L.icon({iconUrl: bicycleIconB3, iconSize: [50, 50], iconAnchor: [23, 44], popupAnchor: [0, -44]})
const CurrentIcon = L.icon({iconUrl: currentIcon, iconSize: [40, 40]})
/**
 * this is not a component, just a wrapper. Use it like a simple Function not a React Component
 */

const Markers = (userPosition, scooters) => {

    let markers = []
    if (scooters) {
        markers = markers.concat(scooters.map((v, index) =>
            <VehicleMarker vehicleId={v.id} position={v.location} battery={v.batteryPercent} key={index}
                           vtype={v.vtype}/>
        ))
    }

    return markers
}

class VehicleMarker extends Component {
    constructor(props) {
        super(props);
        this.state = {isReserve: false}
    }

    info = () => {
        const comp = this
        Modal.info({
            title: 'راهنمای رزرو',
            okText: 'متوجه شدم',
            content: (
                <div className={'info-guide'}>
                    <h3>زمان در اختیار</h3>
                    <h2>09:59</h2>
                    <h4>تا رسیدن به اسکوتر</h4>
                </div>
            ),
            onOk() {
                comp.setState({isReserve: true})
            },
        });
    }

    openDirection = (e) => {
        const {position} = this.props
        const mapUrl = new URL("https://www.google.com/maps/dir/")
        mapUrl.searchParams.append('api', '1')
        mapUrl.searchParams.append('destination', position.lat + ',' + position.lon)

        window.open(mapUrl.toString(), "_blank")
    }

    playBeep = (vehicleId) => {
        getRideApi().rideBeepUnconditional({vehicleId:vehicleId})
            .then((_) => message.info("دستور ارسال شد."))
            .catch((reason) => {
                message.error("خطا در بوق زدن!");
            });
    }

    render() {
        const {vehicleId, position, battery, vtype} = this.props
        const icon = vtype === 'BIKE' ?
            (battery >= 75 ? BicycleIconB3 : (battery >= 40 ? BicycleIconB2 : BicycleIconB1)) :
            (battery >= 75 ? ScooterIconB3 : (battery >= 40 ? ScooterIconB2 : ScooterIconB1))
        const vehicleImage = vtype === 'BIKE' ? bike : scooter
        return (
            <Marker position={position} icon={icon}>
                <Popup closeButton={false} maxWidth="200">
                    <div className='p-1'>
                        {vtype === 'BIKE' && <div>
                            <Row>
                                <Col span={12} className='text-right'>
                                    <span className='f-18 '> دوچرخه</span>
                                </Col>
                                <Col span={12}>
                                    <img className='map-marker-image m-1' src={bike} alt=""/>
                                </Col>
                            </Row>
                            <Row justify='center'>
                                <Button className='popup-button map-marker-btn half-width'
                                        block type='primary'
                                        onClick={this.openDirection}>
                                    مسیریابی
                                </Button>
                            </Row>
                        </div>}
                        {vtype === 'SCOOTER' && <div><Row>
                            <Col span={12} className='text-right'>
                                <div className='f-18 mb-1 '> اسکوتر برقی</div>
                                <div className='f-14'>
                                    {battery}%
                                </div>
                                <div className='battery-bars'>
                                    {battery > 66 && <span className='battery-bar'></span>}
                                    {battery > 33 && <span className='battery-bar'></span>}
                                    {battery && <span className='battery-bar'></span>}
                                </div>
                            </Col>
                            <Col span={12}>
                                <img className='map-marker-image m-1' src={vehicleImage} alt=""/>
                            </Col>
                        </Row>
                            <Row gutter={8}>
                                <Col span={12}><Button className=' map-marker-btn'
                                                       type='primary'
                                                       onClick={this.openDirection}>
                                    مسیریابی
                                </Button></Col>
                                <Col span={12}><Button className='map-marker-btn btn-bordered color-primary bell-btn'
                                                       onClick={(_) => this.playBeep(vehicleId)}
                                                       type='primary'>
                                    <img src={ring} alt=""/>
                                    <span>زنگ</span>
                                </Button></Col>


                            </Row>
                        </div>}
                        {vtype === 'FREEGOV3' && <div><Row>
                            <Col span={12} className='text-right'>
                                <div className='f-18 mb-1 '> اسکوتر نسل ۳</div>
                                <div className='f-14'>
                                    {battery}%
                                </div>
                                <div className='battery-bars'>
                                    {battery > 66 && <span className='battery-bar'></span>}
                                    {battery > 33 && <span className='battery-bar'></span>}
                                    {battery && <span className='battery-bar'></span>}
                                </div>
                            </Col>
                            <Col span={12}>
                                <img className='map-marker-image m-1' src={vehicleImage} alt=""/>
                            </Col>
                        </Row>
                            <Row gutter={8}>
                                <Col span={12}><Button className=' map-marker-btn'
                                                       type='primary'
                                                       onClick={this.openDirection}>
                                    مسیریابی
                                </Button></Col>
                                <Col span={12}><Button className='map-marker-btn btn-bordered color-primary bell-btn'
                                                       onClick={(_) => this.playBeep(vehicleId)}
                                                       type='primary'>
                                    <img src={ring} alt=""/>
                                    <span>زنگ</span>
                                </Button></Col>


                            </Row>
                        </div>}

                    </div>
                    {/* <div className='popup-text'>
                        <span> No:xxx110 </span>
                        <img className={'popup-icon'} src={codeNo} width={24} />
                    </div> */}
                    {/*<div className='popup-text' style={{direction: "ltr"}}>
                        <span>{battery} %</span>
                        <img className={'popup-icon'} src={batteryIcon} width={24} />
                    </div>*/}


                    {/*{
                        (this.state.isReserve) ?
                            <Button className='popup-button'
                                block type='primary'
                                onClick={event => this.setState({ isReserve: false })}>
                                لغو رزرو
                            </Button> :
                            <Button className='popup-button' block type='primary'
                                onClick={this.info}
                            >رزرو</Button>
                    }*/}
                    {/*<ReserveGuide visible={guideVisible} title={'راهنمای رزرو'} onOk={handleOk}/>*/}
                </Popup>
            </Marker>
        )
    }
}


export const Map = ({userPosition, vehicles = [], viewport, onViewportChanged}) => {
    return <LeafletMap scrollWheelZoom={false} viewport={viewport}
                       zoomControl={false} onViewportChanged={onViewportChanged}>
        <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />
        {(userPosition!==null && userPosition!==undefined)?
            <Marker position={userPosition} icon={CurrentIcon} key={'current-'}>
            </Marker>:null}


        <MarkerClusterGroup>
            {Markers(userPosition, vehicles)}
        </MarkerClusterGroup>
    </LeafletMap>

}
